const FindProductType=async (apiHandler,endpoint,authToken,setProductTypeList, setProductType )=>{
    const result = await apiHandler({
        url: endpoint.FIND_ALL_PRODUCT_TYPE,
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        console.log("Error in MasterState Api");
      } else {
     
        const activeData = result?.data?.filter((item)=> item?.active === true)
        setProductTypeList(activeData)
        if(activeData?.length === 1){
          setProductType(activeData?.[0]?.code)
        }
      }
}

export default FindProductType;
